import '@ant-design/compatible/assets/index.css';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import React from 'react';
import modal from '~components/modal';
import PromotionEditor from './editor';

@modal(
  {
    className: 'partner-register-city-editor-modal',
  },
  true,
)
class PromotionEditorContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, partnerId, country, seletedPromotionId, params, paymentPreference } = this.props;

    return (
      <div className="partner-register-city-editor">
        <div className="partner-register-city-editor__header" style={{ paddingBottom: '24px' }}>
          Assign Promotion
          {/* {t(`cms.referral.partner.detail.editor.register_city.title`)} */}
          <CloseOutlined
            className="partner-register-city-editor__close-button"
            onClick={this.props.handleCloseModal}
          />
        </div>

        <PromotionEditor
          t={t}
          paymentPreference={paymentPreference}
          partnerId={partnerId}
          country={country}
          params={params}
          seletedPromotionId={seletedPromotionId}
          onClose={this.props.handleCloseModal}
        />
      </div>
    );
  }
}

PromotionEditorContainer.propTypes = {
  t: PropTypes.func.isRequired,
  editParams: PropTypes.object.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

PromotionEditorContainer.defaultProps = {
  t: () => {},
  editParams: {},
  handleCloseModal: () => {},
};

export default PromotionEditorContainer;
